// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { EventTriggerType } from "./Shared.Models.Api.V1.EventTriggers.EventTriggerType.gen";

export interface IDriverSummaryAlert {
	triggerId: string | undefined;

	triggerType: EventTriggerType;

	isProvisioned: boolean;

	name: string | undefined;

	zoneName: string | undefined;

	isEnabled: boolean | undefined;

	effectiveEnabled: boolean;

	isOverridden: boolean;

	isLocked: boolean;

	minValue: number | undefined;

	maxValue: number | undefined;

	additionalValue: number | undefined;

	$type?: string | undefined;
}
export class DriverSummaryAlert {
	constructor(data?: IDriverSummaryAlert) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	triggerId: string | undefined;

	triggerType: EventTriggerType = 0;

	isProvisioned: boolean = false;

	name: string | undefined;

	zoneName: string | undefined;

	isEnabled: boolean | undefined;

	effectiveEnabled: boolean = false;

	isOverridden: boolean = false;

	isLocked: boolean = false;

	minValue: number | undefined;

	maxValue: number | undefined;

	additionalValue: number | undefined;

	static $type: string = "CoreApi.Models.DriverSummaryAlert, ";
	$type?: string | undefined = DriverSummaryAlert.$type;
}

